export default "__VITE_ASSET__D_pk$7uv__"